import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from './ComponentSync.js';
import { generateUUID } from '@nu-art/ts-common';
import { Thunder } from './Thunder.js';
import { stopPropagation } from '../utils/tools.js';
import { ModuleFE_RoutingV2 } from '../modules/routing/ModuleFE_RoutingV2.js';
import { TS_DialogOverlay } from '../components/TS_Dialog/index.js';
import { TS_PopUp, TS_ToolTip } from '../components/TS_MouseInteractivity/index.js';
import { TS_ToastOverlay } from '../components/TS_Toaster/index.js';
import { TS_Notifications } from '../components/TS_Notifications/index.js';
import { TS_MemoryMonitor } from '../components/TS_MemoryMonitor/index.js';
export class ThunderstormDefaultApp extends ComponentSync {
    static blockEvent(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }
    getAdditionalOverlayRenderer(overlay) {
        const Renderer = overlay;
        return _jsx(Renderer, {}, generateUUID());
    }
    deriveStateFromProps(nextProps) {
        return {};
    }
    render() {
        // @ts-ignore
        const blockRightClick = !Thunder.getInstance().config.isDebug;
        return (_jsxs("div", { id: "app", onDrop: stopPropagation, onDragOver: stopPropagation, onContextMenu: blockRightClick ? stopPropagation : undefined, children: [ModuleFE_RoutingV2.generateRoutes(this.props.rootRoute), _jsx(TS_DialogOverlay, {}), _jsx(TS_PopUp, {}), _jsx(TS_ToolTip, {}), _jsx(TS_ToastOverlay, {}), _jsx(TS_Notifications, {}), _jsx(TS_MemoryMonitor, {}), this.props.additionalOverlays?.map(Overlay => this.getAdditionalOverlayRenderer(Overlay))] }));
    }
}
//# sourceMappingURL=ThunderstormDefaultApp.js.map